// extracted by mini-css-extract-plugin
module.exports = {"offwhite":"#FAFAFA","mobile":"500px","container":"CancellationDisclaimer_container__YxMeI","header":"CancellationDisclaimer_header__XWt_W"};